
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/amsterdam-dance-event-demo-drops-2024",
      function () {
        return require("private-next-pages/amsterdam-dance-event-demo-drops-2024/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/amsterdam-dance-event-demo-drops-2024"])
      });
    }
  